module.exports = __webpack_public_path__ + "img/php.f23752cc.svg";